import { render, staticRenderFns } from "./RoomAddonsView.vue?vue&type=template&id=45e3a151&scoped=true&"
import script from "./RoomAddonsView.vue?vue&type=script&lang=js&"
export * from "./RoomAddonsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3a151",
  null
  
)

export default component.exports